import local from 'local-links';

export default (container = document) => {
	[...container.querySelectorAll('a')]
		.filter(
			a =>
				// pure-fragment hrefs only; `/path#hash` links are still local —
				// activeLinks applies a broader contains-'#' rule for a different reason
				!(a.getAttribute('href') || '').startsWith('#') &&
				local.isLocal('click', a, true) === null &&
				a.href !== window.location.href
		)
		.forEach(a => {
			const rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
			a.setAttribute('target', '_blank');
			a.setAttribute(
				'rel',
				[...new Set([...rel, 'noopener', 'noreferrer'])].join(' ')
			);
		});
};
